import React, { useState, useEffect } from "react";
import { Dropdown, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import PageTitle from "../../../../layouts/PageTitle";
import { useGetContractorsQuery } from "../../../../../store/appApi";
import { selectHasModuleAccess } from "../../../../../store/authSlice";

const theadData = [
  { heading: "S.No." },
  { heading: "Name" },
  { heading: "Phone" },
  { heading: "Category" },
  { heading: "GST Number" },
  { heading: "Address" },
  { heading: "Action" },
];

const ContractorList = () => {
  const hasContractorsWrite = useSelector(selectHasModuleAccess("contractors", "read-write"));
  const [sort, setSortata] = useState(10);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // ── Debounce search ────────────────────────────────────────────────────────
  useEffect(() => {
    const t = setTimeout(() => {
      setDebouncedSearch(searchTerm.trim());
      setPage(1);
    }, 350);
    return () => clearTimeout(t);
  }, [searchTerm]);

  // ── GET via Redux ──────────────────────────────────────────────────────────
  const {
    data: contractorsResponse,
    isLoading,
    isFetching,
  } = useGetContractorsQuery();

  const rawList = Array.isArray(contractorsResponse?.data)
    ? contractorsResponse.data
    : [];

  // Client-side search
  const filtered = debouncedSearch
    ? rawList.filter((c) =>
        `${c.name} ${c.phone} ${c.address} ${c.gstNumber} ${c.catName || ""}`
          .toLowerCase()
          .includes(debouncedSearch.toLowerCase()),
      )
    : rawList;

  const total = filtered.length;
  const totalPages = Math.ceil(total / Number(sort)) || 1;
  const pageData = filtered.slice(
    (page - 1) * Number(sort),
    page * Number(sort),
  );
  const paggination = Array(totalPages)
    .fill()
    .map((_, i) => i + 1);
  const showingFrom = total > 0 ? (page - 1) * Number(sort) + 1 : 0;
  const showingTo = total > 0 ? Math.min(page * Number(sort), total) : 0;
  const showLoading = isLoading || isFetching;

  return (
    <>
      <PageTitle activeMenu={"All Contractors"} motherMenu={"Inventory"} />
      <Row>
        <Col lg={12}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Contractor List</h4>
              {hasContractorsWrite && (
                <Link to={"/add-contractor"} className="btn btn-primary">
                  + Add New
                </Link>
              )}
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <div className="dataTables_wrapper no-footer">
                  <div className="justify-content-between d-sm-flex">
                    <div className="dataTables_length">
                      <label className="d-flex align-items-center">
                        Show
                        <Dropdown className="search-drop">
                          <Dropdown.Toggle as="div" className="search-drop-btn">
                            {sort}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() => {
                                setSortata(10);
                                setPage(1);
                              }}
                            >
                              10
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setSortata(20);
                                setPage(1);
                              }}
                            >
                              20
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setSortata(30);
                                setPage(1);
                              }}
                            >
                              30
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        entries
                      </label>
                    </div>
                    <div className="dataTables_filter">
                      <label>
                        Search:{" "}
                        <input
                          type="search"
                          className=""
                          placeholder=""
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </label>
                    </div>
                  </div>
                  <table className="display dataTable no-footer w-100">
                    <thead>
                      <tr>
                        {theadData.map((item, ind) => (
                          <th key={ind}>{item.heading}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {showLoading && (
                        <tr>
                          <td colSpan={7}>Loading contractors...</td>
                        </tr>
                      )}
                      {!showLoading && pageData.length === 0 && (
                        <tr>
                          <td colSpan={7}>No contractors found.</td>
                        </tr>
                      )}
                      {!showLoading &&
                        pageData.map((item, ind) => (
                          <tr key={item._id || ind}>
                            <td>{(page - 1) * Number(sort) + ind + 1}</td>
                            <td style={{ textTransform: "capitalize" }}>
                              {item.name || "—"}
                            </td>
                            <td>{item.phone || "—"}</td>
                            <td style={{ textTransform: "capitalize" }}>
                              {item.catName || "—"}
                            </td>
                            <td>{item.gstNumber || "—"}</td>
                            <td>{item.address || "—"}</td>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                {/* <Link
                                to={`/contractor-profile/${item._id}`}
                                className="btn btn-xs btn-outline-info"
                              >
                                View
                              </Link> */}
                                {hasContractorsWrite && (
                                  <Link
                                    to={`/edit-contractor/${item._id}`}
                                    className="btn btn-xs sharp btn-primary"
                                  >
                                    <i className="fa fa-pencil" />
                                  </Link>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                    <div className="dataTables_info">
                      Showing {showingFrom} to {showingTo} of {total} entries
                    </div>
                    <div className="dataTables_paginate paging_simple_numbers">
                      <Link
                        className={`paginate_button previous ${page <= 1 ? "disabled" : ""}`}
                        to="#"
                        onClick={() => page > 1 && setPage(page - 1)}
                      >
                        Previous
                      </Link>
                      <span>
                        {paggination.map((number, i) => (
                          <Link
                            key={i}
                            to="#"
                            className={`paginate_button ${page === number ? "current" : ""}`}
                            onClick={() => setPage(number)}
                          >
                            {number}
                          </Link>
                        ))}
                      </span>
                      <Link
                        className={`paginate_button next ${page >= totalPages ? "disabled" : ""}`}
                        to="#"
                        onClick={() => page < totalPages && setPage(page + 1)}
                      >
                        Next
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ContractorList;
